import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSliderModule } from '@angular/material/slider';
import { TranslateModule } from '@ngx-translate/core';
import { EInvoiceSignUpModule } from '../shared/components/e-invoice-sign-up/e-invoice-sign-up.module';
import { NotificationsModule } from '../shared/components/notifications/notifications.module';
import { S3FileDownloaderModule } from '../shared/components/s3-file-downloader/s3-file-downloader.module';
import { AutoRedeemDialogComponent } from '../shared/services/dialog/auto-redeem-dialog/auto-redeem-dialog.component';
import {
    SuccessfulRedeemDialogComponent,
} from '../shared/services/dialog/successful-redeem-dialog/successful-redeem-dialog.component';
import { SharedModule } from '../shared/shared.module';
import { AddEditLocationComponent } from './add-edit-location/add-edit-location.component';
import { ChangePasswordModule } from './change-password/change-password.module';
import { CustomPaginatorModule } from './digital-wallet/components/custom-paginator/custom-paginator.module';
import {
    TermsConditionsDialogComponent,
} from './digital-wallet/components/terms-conditions-dialog/terms-conditions-dialog.component';
import { DwDashboardComponent } from './digital-wallet/dw-dashboard/dw-dashboard.component';
import { DwDashboardResolver } from './digital-wallet/dw-dashboard/dw-dashboard.resolver';
import {
    DwRewardshipAdvancedFilterChipComponent,
} from './digital-wallet/dw-rewardship/dw-rewardship-advanced-filter-chips/chip/dw-rewardship-advanced-filter-chip.component';
import {
    DwRewardshipAdvancedFilterChipsComponent,
} from './digital-wallet/dw-rewardship/dw-rewardship-advanced-filter-chips/dw-rewardship-advanced-filter-chips.component';
import {
    DwRewardShipAdvancedFilterComponent,
} from './digital-wallet/dw-rewardship/dw-rewardship-advanced-filter/dw-rewardship-advanced-filter.component';
import { DwRewardshipComponent } from './digital-wallet/dw-rewardship/dw-rewardship.component';
import { DwRewardshipResolver } from './digital-wallet/dw-rewardship/dw-rewardship.resolver';
import { InvoiceCardComponent } from './digital-wallet/dw-rewardship/invoice-card/invoice-card.component';
import { InvoiceStatusColorPipe } from './digital-wallet/dw-rewardship/invoice-card/invoice-status-color.pipe';
import { DigitalWalletService } from './digital-wallet/services/digital-wallet.service';
import { ManageLocationComponent } from './manage-locations/manage-location/manage-location.component';
import { ManageLocationsComponent } from './manage-locations/manage-locations.component';
import { AddEditUserComponent } from './manage-users/add-edit-user/add-edit-user.component';
import { ManageUsersComponent } from './manage-users/manage-users.component';
import { Address } from './models/address.model';
import { RewardshipRulesComponent } from './rewardship/rewardship-rules/rewardship-rules.component';
import { RewardshipTableComponent } from './rewardship/rewardship-table/rewardship-table.component';
import { RewardshipComponent } from './rewardship/rewardship.component';
import { RewardshipResolver } from './rewardship/rewardship.resolver';
import { ManageLocationsService } from './services/manage-locations.service';
import { ManageUsersService } from './services/manage-users.service';
import { RewardshipService } from './services/rewardship.service';
import { UserSettingsComponent } from './user-settings/user-settings.component';
import { UserTermsConditionsComponent } from './user-settings/user-terms-conditions/user-terms-conditions.component';
import { UserTermsUseComponent } from './user-settings/user-terms-use/user-terms-use.component';
import { PopupComponent } from './user-settings/popup/popup.component';
import { ClipboardModule } from '@angular/cdk/clipboard';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        TranslateModule,
        ReactiveFormsModule,
        EInvoiceSignUpModule,
        MatPaginatorModule,
        MatSliderModule,
        NotificationsModule,
        S3FileDownloaderModule,
        CustomPaginatorModule,
        ChangePasswordModule,
        ClipboardModule
    ],
    declarations: [
        ManageLocationsComponent,
        UserSettingsComponent,
        ManageUsersComponent,
        AddEditUserComponent,
        AddEditLocationComponent,
        RewardshipComponent,
        RewardshipTableComponent,
        RewardshipRulesComponent,
        UserTermsConditionsComponent,
        UserTermsUseComponent,
        ManageLocationComponent,
        DwRewardshipComponent,
        DwDashboardComponent,
        TermsConditionsDialogComponent,
        AutoRedeemDialogComponent,
        SuccessfulRedeemDialogComponent,
        InvoiceCardComponent,
        InvoiceStatusColorPipe,
        DwRewardShipAdvancedFilterComponent,
        DwRewardshipAdvancedFilterChipComponent,
        DwRewardshipAdvancedFilterChipsComponent,
        PopupComponent,
    ],
    providers: [
        ManageLocationsService,
        Address,
        ManageUsersService,
        RewardshipService,
        CurrencyPipe,
        DigitalWalletService,
        RewardshipResolver,
        DwDashboardResolver,
        DwRewardshipResolver,
    ],
    exports: [
        UserSettingsComponent,
        RewardshipTableComponent,
        UserTermsConditionsComponent,
        UserTermsUseComponent,
        ManageLocationComponent,
    ],
})
export class AccountModule {
}
